/**
 * Who sees Invoicing → Accounting and who may retry, mirroring the API: kept
 * free of service imports so the Invoicing section list can use it.
 */

/** People with accounting access (or staff) see the Accounting tab. */
export function canSeeAccounting(permissions: string[] = []): boolean {
  return ['system:admin', 'accounting:view', 'accounting:configure', 'integrations:manage'].some((p) => permissions.includes(p));
}

/** Who may send invoices to accounting again (the bulk sync's rule). */
export function canRetryAccounting(permissions: string[] = []): boolean {
  return ['system:admin', 'accounting:configure', 'integrations:manage'].some((p) => permissions.includes(p));
}
